// extracted by mini-css-extract-plugin
module.exports = {"gift":"nj5wYWBM","img":"DuyDIDpw","done":"KE4APv08","modalWrap":"__7T57_rUK"};